"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var styles = {
  "main-content-width": "main-content-width_26XjuL",
  "mainContentWidth": "main-content-width_26XjuL",
  "middle-content-width": "middle-content-width_28mrKy",
  "middleContentWidth": "middle-content-width_28mrKy",
  "full-width": "full-width_9v-u0p",
  "fullWidth": "full-width_9v-u0p",
  "detailed-content-width": "detailed-content-width_I_LXD1",
  "detailedContentWidth": "detailed-content-width_I_LXD1",
  "content": "content_2fseB6"
}; 
require('./Main.css');
var Main = function Main(_ref) {
  var hasSidebar = _ref.hasSidebar,
    hasDetail = _ref.hasDetail,
    children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("section", {
    "aria-label": "Main content",
    className: (0, _classnames.default)(styles.content, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, styles.fullWidth, !hasSidebar && !hasDetail), styles.mainContentWidth, hasSidebar && !hasDetail), styles.middleContentWidth, hasSidebar && hasDetail), styles.detailedContentWidth, !hasSidebar && hasDetail)),
    "data-test-id": "layout-middle-content"
  }, children);
};
Main.propTypes = {
  hasSidebar: _propTypes.default.bool,
  hasDetail: _propTypes.default.bool,
  children: _propTypes.default.node
};
var _default = exports.default = Main;
//# sourceMappingURL=Main.js.map